import { Outlet, Navigate } from 'react-router-dom';
import { useIsAthenticatedUser } from '../utils/utils';

const PrivateRoutes = () => {
  return useIsAthenticatedUser() ? <Outlet /> : <Navigate to='/login' />;
};

export default PrivateRoutes;
